import { render, staticRenderFns } from "./Noo.vue?vue&type=template&id=7a184f14&"
import script from "./Noo.vue?vue&type=script&lang=js&"
export * from "./Noo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports